import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import EstablishmentOverview from "./views/EstablishmentOverview";
import EstablishmentDetail from "./views/EstablishmentDetail";

function App(props) {
    const {
        feedBaseUrl,
        country,
        locale,
        defaultBrand,
        defaultService,
        mainPageUrl,
        siteTitle,
        pageTitle,
        metaTitle,
        metaDescription,
        socialDescription,
        metaImage,
        routerBasename,
        detailCards,
        workplacePageUrl,
        contactPageUrl,
        autoschadeRumblePageUrl,
    } = props;

    const { origin } = new URL(window.location.href);

    const [mapsLoaded, setMapsLoaded] = useState(false);
    const [tagsLoaded, setTagsLoaded] = useState(false);
    const [countryTag, setCountryTag] = useState();
    const [establishmentList, setEstablishmentList] = useState({
        loading: true,
        data: {},
        error: false,
    });

    const [isFirstLocation, setIsFirstLocation] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (
            isFirstLocation === true &&
            Object.keys(establishmentList.data).length
        ) {
            setIsFirstLocation(false);
        }

        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        let tagsBasedOnCountry = false;
        if (country === "be") {
            tagsBasedOnCountry = "Belgie";
        } else if (country === "nl") {
            tagsBasedOnCountry = "Nederland";
        } else if (country === "lu") {
            tagsBasedOnCountry = "luxemburg";
        }

        setCountryTag(tagsBasedOnCountry);

        setTagsLoaded(true);
    }, [country]);

    // GET DATA TO BUILD FILTERS
    useEffect(() => {
        if (!tagsLoaded) {
            return;
        }
        let feed = `${feedBaseUrl}`;
        if (countryTag) {
            feed += `&tags=${countryTag}`;
        }

        fetch(feed)
            .then((response) => response.json())
            .then((data) => {
                // Store the establishments keyed by slug
                const EstablishmentsBySlug = {};
                data.result.forEach((element) => {
                    EstablishmentsBySlug[element.slug] = element;
                });
                setEstablishmentList({
                    loading: false,
                    data: EstablishmentsBySlug,
                    error: data.status !== "OK",
                });
            })
            .catch(() => {
                setEstablishmentList({
                    loading: false,
                    data: {},
                    error: true,
                });
            });
    }, [feedBaseUrl, locale, tagsLoaded, countryTag]);

    // Render the component
    //   if (Object.keys(establishmentList.data).length) {
    return (
        <>
            <Helmet titleTemplate={`%s | ${siteTitle}`} />
            <Routes>
                {/* Index of all establishments */}
                <Route
                    exact
                    path="/"
                    element={
                        <EstablishmentOverview
                            mapsLoaded={mapsLoaded}
                            baseName={routerBasename}
                            setMapsLoaded={setMapsLoaded}
                            feedBaseUrl={feedBaseUrl}
                            // tags={countryTag}
                            // country={country}
                            // locale={locale}
                            origin={origin}
                            pageTitle={pageTitle}
                            metaTitle={metaTitle}
                            metaDescription={metaDescription}
                            socialDescription={socialDescription}
                            metaImage={metaImage}
                            siteTitle={siteTitle}
                            // defaultBrand={defaultBrand}
                            // defaultService={defaultService}
                            // isFirstLocation={isFirstLocation}
                        />
                    }
                />
                {/* Detail page
          <Route
            path="/:slug"
            element={
              <EstablishmentDetail
                workplacePageUrl={workplacePageUrl}
                contactPageUrl={contactPageUrl}
                autoschadeRumblePageUrl={autoschadeRumblePageUrl}
                isFirstLocation={isFirstLocation}
                establishmentList={establishmentList}
                siteTitle={siteTitle}
                locale={locale}
                origin={origin}
                baseName={routerBasename}
                mapsLoaded={mapsLoaded}
                feedBaseUrl={feedBaseUrl}
                mainPageUrl={mainPageUrl}
                metaImage={metaImage}
                cards={detailCards}
                setMapsLoaded={setMapsLoaded}
              />
            }
            //   // Show the detail page
            //   // If the slug is not existent, redirect back to index
            //   establishmentList.data[match.params.slug] ? (
            //     // eslint-disable-next-line max-len
            //   ) : (
            //     <Navigate to="/" />
            //   )
            // }
          /> */}
            </Routes>
        </>
    );
    //   }

    //   if (establishmentList.error) {
    //     return (
    //       <section className="layer">
    //         <div className="site-width">{ss.i18n._t("EstablishmentApp.ERROR")}</div>
    //       </section>
    //     );
    //   }

    return (
        <>
            <Helmet titleTemplate={`%s | ${siteTitle}`} />
            <Routes>
                {/* Ghost template for overview */}
                <Route
                    exact
                    path="/"
                    element={
                        <section className="map">
                            <aside className="map__aside">
                                <div className="island bg--neutral-xlight">
                                    <span
                                        className="ghost-element ghost-element--line sign-s"
                                        style={{ width: "100px" }}
                                    />
                                    <span className="ghost-element ghost-element--line-xl" />
                                    <div className="text-right">
                                        <img
                                            src="/_resources/themes/schellevis/img/powered_by_google_on_white.png"
                                            width="144"
                                            height="18"
                                            alt="Powered by Google"
                                            className="hidden--gt-palm"
                                        />
                                    </div>
                                    <div className="sign-s" />
                                    <span
                                        className="ghost-element ghost-element--line sign-s"
                                        style={{ width: "120px" }}
                                    />
                                    <div className="layout layout--fit layout--gutter">
                                        <div className="layout__cell unit-6-12--desk unit-1-1 sign-s">
                                            <span className="ghost-element ghost-element--line-xl" />
                                        </div>
                                        <div className="layout__cell unit-6-12--desk unit-1-1 sign-s">
                                            <span className="ghost-element ghost-element--line-xl" />
                                        </div>
                                    </div>
                                </div>
                                <div className="map-list">
                                    <div className="map-list__item">
                                        <div className="map-list__item-content">
                                            <div className="ghost-element-holder ghost-element-holder--lines">
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "180px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "160px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "150px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "175px" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="map-list__item-actions">
                                            <div
                                                className="ghost-element ghost-element--button"
                                                style={{ width: "176px" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="map-list__item">
                                        <div className="map-list__item-content">
                                            <div className="ghost-element-holder ghost-element-holder--lines">
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "180px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "160px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "150px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "175px" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="map-list__item-actions">
                                            <div
                                                className="ghost-element ghost-element--button"
                                                style={{ width: "176px" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="map-list__item">
                                        <div className="map-list__item-content">
                                            <div className="ghost-element-holder ghost-element-holder--lines">
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "180px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "160px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "150px" }}
                                                />
                                                <span
                                                    className="ghost-element ghost-element--line"
                                                    style={{ width: "175px" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="map-list__item-actions">
                                            <div
                                                className="ghost-element ghost-element--button"
                                                style={{ width: "176px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </section>
                    }
                />
                {/* Ghost template for Detail page */}
                {/* <Route path="/:slug" element={
          <section className="layer">
            <div className="image-content sign-inv">
              <div className="site-width">
                <div className="layout layout--fit layout--gutter layout--middle">
                  <div className="layout__cell unit-6-12--gt-palm unit-1-1 sign">
                    <figure className="image-content__visual visual ratio--4x3" />
                  </div>
                  <div className="layout__cell unit-5-12--desk unit-6-12--lap push-1-12--desk unit-1-1 sign">
                    {ss.i18n._t("EstablishmentApp.LOADING")}
                  </div>
                </div>
              </div>
            </div>
          </section>
        } />*/}
            </Routes>
        </>
    );
}

App.propTypes = {
    feedBaseUrl: PropTypes.string.isRequired,
    country: PropTypes.string,
    locale: PropTypes.string,
    pageTitle: PropTypes.string.isRequired,
    siteTitle: PropTypes.string,
    metaTitle: PropTypes.string,
    mainPageUrl: PropTypes.string,
    metaDescription: PropTypes.string,
    socialDescription: PropTypes.string,
    metaImage: PropTypes.string.isRequired,
    defaultBrand: PropTypes.string,
    defaultService: PropTypes.string,
    routerBasename: PropTypes.string,
    workplacePageUrl: PropTypes.string,
    autoschadeRumblePageUrl: PropTypes.string,
    contactPageUrl: PropTypes.string,
    detailCards: PropTypes.object,
};

App.defaultProps = {
    defaultBrand: "",
    defaultService: "",
    siteTitle: "Schellevis",
    metaTitle: "Dealerlocator",
    metaDescription: "Dealers",
    socialDescription: "Dealers",
    routerBasename: "/",
    workplacePageUrl: "/",
    contactPageUrl: "/",
    autoschadeRumblePageUrl: "/",
    detailCards: {},
};

export default App;
